import { Link } from 'react-router-dom';
import { useAuth } from '../lib/useAuth';

// Route guard for /admin: requires role staff|admin (RLS enforces server-side too).
export default function RequireStaff({ children }) {
  const { loading, session, isStaff } = useAuth();

  if (loading) return <div className="loading">Đang kiểm tra quyền truy cập...</div>;

  if (!session) {
    return (
      <div className="empty">
        <h3>Cần đăng nhập</h3>
        <p>Trang quản trị chỉ dành cho nhân viên.</p>
        <Link className="btn btn-primary" to="/login">Đăng nhập</Link>
      </div>
    );
  }

  if (!isStaff) {
    return (
      <div className="empty">
        <h3>Không có quyền truy cập</h3>
        <p>Tài khoản của bạn chưa được cấp quyền nhân viên. Liên hệ quản lý để được cấp quyền (role: staff hoặc admin).</p>
        <Link className="btn btn-secondary" to="/">Về trang chủ</Link>
      </div>
    );
  }

  return children;
}
